import { render, staticRenderFns } from "./modalCaracteristicas.vue?vue&type=template&id=09005134&scoped=true&"
import script from "./modalCaracteristicas.vue?vue&type=script&lang=js&"
export * from "./modalCaracteristicas.vue?vue&type=script&lang=js&"
import style0 from "./modalCaracteristicas.vue?vue&type=style&index=0&id=09005134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09005134",
  null
  
)

export default component.exports